<template>
  <page :title="i18n.title">
    <div class="order-warp" v-if="items.length">
      <div class="order-items" v-for="item in items" :key="item.pId">
        <img src="../../assets/imgs/icon_gift2.png" alt="" srcset="">
        <div class="order-item-info">
          <h2>{{ item.pmian }} {{ $t('home.minute') }}</h2>
          <p>{{ i18n.expiretime }}: {{ item.pEnd | dateFmt }}</p>
        </div>
      </div>
    </div>
    <result-msg
      v-else
      :loading="loading"
      :text="error"
      @click="loadList"
    ></result-msg>
  </page>
</template>

<script>
import { COUPON_LIST } from "../../apis/user"
import ResultMsg from "../../components/result/msg.vue"
import i18n from "../../i18n"
export default {
  components: {
    ResultMsg
  },
  computed: {
    i18n() {
      return this.$t("coupon")
    }
  },
  data() {
    return {
      items: [],
      error: "",
      loading: false
    }
  },
  methods: {
    loadList(page = 1) {
      this.loading = true
      this.$loading(true)
      this.$get(
        COUPON_LIST,
        {
          page,
          pageSize: 10
        },
        (resp) => {
          this.loading = false
          this.$loading(false)
          if (resp.list) {
            this.error = ""
            this.items = resp.list.records
          } else {
            this.error = this.i18n.msg_error
          }
        },
        (error) => {
          this.loading = false
          this.$loading(false)
          this.error = error
        }
      )
    }
  },
  created() {
    this.loadList()
  }
}
</script>

<style lang="less">
.order-warp {
  padding: 48px;
  .order-items {
    background: #fff;
    color: #000;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-radius: 20px;
    img {
      width: 20%;
    }
    .order-item-info {
      margin-left: 20px;
      h2, p {
        margin: 10px 0;
      }
    }
  }
}
</style>
